/* =============================================================================
   assets/custom-header.js
   -----------------------------------------------------------------------------
   Small, self-contained behaviours for sections/header.liquid:
     1. Toggles a "scrolled" class on the header once the page scrolls past
        a threshold, so CSS can shrink it smoothly (see custom-theme.css,
        section 7).
     2. Opens/closes the mobile menu drawer.
     3. Opens/closes the search flyout.

   The desktop mega menu itself needs no JS at all — it opens on
   hover/focus via plain CSS (:hover / :focus-within), which is both
   simpler and more reliable than a hover-simulated-by-JS approach.

   Nothing here touches window.routes, window.cartStrings, or any other
   global set up in layout/theme.liquid, and nothing here interferes with
   the existing cart-drawer.js (the cart icon link just reuses its
   "cart-icon-bubble" id so that script's own listener picks it up).
============================================================================= */
(function () {
  'use strict';

  /* -----------------------------------------------------------------------
     1. Sticky header shrink-on-scroll
  ----------------------------------------------------------------------- */
  var header = document.querySelector('[data-site-header]');

  if (header && header.dataset.sticky === 'true') {
    var SCROLL_THRESHOLD = 24;
    var ticking = false;

    var updateScrolledState = function () {
      var isScrolled = window.scrollY > SCROLL_THRESHOLD;
      header.classList.toggle('site-header--scrolled', isScrolled);
      ticking = false;
    };

    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          window.requestAnimationFrame(updateScrolledState);
          ticking = true;
        }
      },
      { passive: true }
    );

    updateScrolledState();
  }

  /* -----------------------------------------------------------------------
     2. Mobile nav drawer
  ----------------------------------------------------------------------- */
  var mobileToggle = document.querySelector('[data-mobile-nav-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  var mobileOverlay = document.querySelector('[data-mobile-nav-overlay]');
  var mobileClose = document.querySelector('[data-mobile-nav-close]');

  function openMobileNav() {
    if (!mobileNav || !mobileOverlay) return;
    mobileNav.hidden = false;
    mobileOverlay.hidden = false;
    window.requestAnimationFrame(function () {
      mobileNav.classList.add('is-open');
      mobileOverlay.classList.add('is-open');
    });
    if (mobileToggle) mobileToggle.setAttribute('aria-expanded', 'true');
    document.body.classList.add('nav-open');
  }

  function closeMobileNav() {
    if (!mobileNav || !mobileOverlay) return;
    mobileNav.classList.remove('is-open');
    mobileOverlay.classList.remove('is-open');
    if (mobileToggle) mobileToggle.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('nav-open');
    window.setTimeout(function () {
      mobileNav.hidden = true;
      mobileOverlay.hidden = true;
    }, 250);
  }

  if (mobileToggle) {
    mobileToggle.addEventListener('click', function () {
      var isOpen = mobileNav && mobileNav.classList.contains('is-open');
      if (isOpen) {
        closeMobileNav();
      } else {
        openMobileNav();
      }
    });
  }

  if (mobileClose) mobileClose.addEventListener('click', closeMobileNav);
  if (mobileOverlay) mobileOverlay.addEventListener('click', closeMobileNav);

  /* -----------------------------------------------------------------------
     3. Search flyout
  ----------------------------------------------------------------------- */
  var searchToggle = document.querySelector('[data-search-toggle]');
  var searchFlyout = document.querySelector('[data-search-flyout]');

  function openSearch() {
    if (!searchFlyout) return;
    searchFlyout.hidden = false;
    window.requestAnimationFrame(function () {
      searchFlyout.classList.add('is-open');
      var input = searchFlyout.querySelector('input[type="search"]');
      if (input) input.focus();
    });
    if (searchToggle) searchToggle.setAttribute('aria-expanded', 'true');
  }

  function closeSearch() {
    if (!searchFlyout) return;
    searchFlyout.classList.remove('is-open');
    if (searchToggle) searchToggle.setAttribute('aria-expanded', 'false');
    window.setTimeout(function () {
      searchFlyout.hidden = true;
    }, 200);
  }

  if (searchToggle) {
    searchToggle.addEventListener('click', function () {
      var isOpen = searchFlyout && searchFlyout.classList.contains('is-open');
      if (isOpen) {
        closeSearch();
      } else {
        openSearch();
      }
    });
  }

  document.addEventListener('click', function (event) {
    if (
      searchFlyout &&
      searchFlyout.classList.contains('is-open') &&
      !searchFlyout.contains(event.target) &&
      event.target !== searchToggle
    ) {
      closeSearch();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    closeSearch();
    closeMobileNav();
  });
})();
